import React, { FunctionComponent } from 'react';
import { Modal, Header } from 'semantic-ui-react';
import withStyles from 'react-jss';
import { useForm, FormProvider } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';

import { ClassProp } from 'helpers/types';
import { useMutation } from 'helpers/useMutation';
import FormInput from 'components/FormComponents/FormInput';

import styles from './CreateOnlineVenue.styles';
import CREATE_ONLINE_VENUE from './CreateOnlineVenue.mutations';

type MatchParams = {
  merchantName: string;
  merchantId: string;
};

type Styles = ClassProp<ReturnType<typeof styles>>;

type FormData = {
  website: string;
  brandId: string;
};

type Props = {
  classes: Styles;
  trigger: any;
  title?: string;
};

const CreateOnlineVenueModal: FunctionComponent<Props> = ({
  title = 'Create Online Venue',
  trigger,
  classes,
}) => {
  const { runMutation, loading } = useMutation(
    CREATE_ONLINE_VENUE,
    {},
    'Online Venue has been created',
    [
      {
        key: 'not supported yet',
        newError: {
          displayMessage: 'Warning',
          message: 'Unable to create online venue',
        },
      },
    ],
  );

  const methods = useForm<FormData>({
    mode: 'onBlur',
  });
  const { register, handleSubmit, errors } = methods;
  const params = useParams<MatchParams>();
  const { merchantId }: MatchParams = params;

  const onSubmit = async ({ website, brandId }: FormData) => {
    runMutation({
      variables: {
        params: {
          website,
          brandId,
          merchantId,
        },
      },
    });
  };

  return (
    <Modal trigger={trigger} closeIcon size="mini">
      <Header className={classes.header} icon="envelope open" content={title} />

      <Modal.Content>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={classes.fieldGroup}>
              <FormInput
                name="website"
                type="text"
                placeholder="Enter url with https"
                label="Website URL"
                tabIndex={9}
                register={register({
                  required: true,
                  validate: {
                    oneOf: (value) =>
                      value.includes('http') || 'URL needs to include http',
                  },
                })}
              />
              <FormInput
                name="brandId"
                type="text"
                placeholder="Enter BrandId"
                label="BrandId"
                tabIndex={9}
                register={register({
                  required: true,
                  pattern: {
                    value: /[A-Z0-9]+$/i,
                    message: 'BrandId needs to be uppercase alphanumeric',
                  },
                })}
              />
            </div>

            <div className={classes.fieldGroup}>
              <input
                disabled={loading}
                type="submit"
                value={'Submit'}
                className={classnames(classes.submit, {
                  [classes.disabled]: loading || !!errors,
                })}
              />
            </div>
          </form>
        </FormProvider>
      </Modal.Content>
    </Modal>
  );
};

export default withStyles(styles)(CreateOnlineVenueModal);
